import React from 'react';
import { ChevronUp, ChevronDown } from 'lucide-react';

export interface MarginCounterProps {
  value: number;
  onChange: (value: number) => void;
  disabled?: boolean;
  min?: number;
  max?: number;
  step?: number;
  className?: string;
}

const MarginCounter: React.FC<MarginCounterProps> = ({
  value,
  onChange,
  disabled = false,
  min = 0,
  max = 100,
  step = 1,
  className = '',
}) => {
  const handleIncrement = () => {
    if (!disabled && value < max) {
      const newValue = Math.min(value + step, max);
      onChange(newValue);
    }
  };

  const handleDecrement = () => {
    if (!disabled && value > min) {
      const newValue = Math.max(value - step, min);
      onChange(newValue);
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = Number(e.target.value);
    if (!isNaN(newValue) && newValue >= min && newValue <= max) {
      onChange(newValue);
    }
  };

  return (
    <div className={`flex items-center bg-transparent ${className}`}>
      <input
        type="number"
        value={value}
        onChange={handleInputChange}
        disabled={disabled}
        min={min}
        max={max}
        className="bg-transparent border-none outline-none text-right w-12 text-3xl appearance-none [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none [-moz-appearance:textfield]"
        onClick={(e) => e.stopPropagation()}
      />
      <span className="text-sm font-medium">
        %
      </span>
      <div className="flex flex-col ml-1">
        <button
          onClick={(e) => {
            handleIncrement();
            e.stopPropagation();
          }}
          disabled={disabled || value >= max}
          className="p-0 h-3 w-4 flex items-center justify-center hover:bg-white hover:bg-opacity-20 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <ChevronUp className="w-3 h-3" />
        </button>
        <button
          onClick={(e) => {
            handleDecrement();
            e.stopPropagation();
          }}
          disabled={disabled || value <= min}
          className="p-0 h-3 w-4 flex items-center justify-center hover:bg-white hover:bg-opacity-20 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <ChevronDown className="w-3 h-3" />
        </button>
      </div>
    </div>
  );
};

export default MarginCounter;